export default "/_next/static/media/SourceSansProBold.6017fce623491e147c1ab98470b01db2.woff2";